import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { quotationList } from "../constants/quotation";

export const addQuotation = async (bodyData) => {
  try {
    const res = await api.add_quotation(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getQuotationList = async (dispatch, jobId) => {
  try {
    const res = await api.get_quotation_detail(jobId);
    dispatch({ type: quotationList, payload: res.data });
  } catch (error) {
    dispatch({ type: quotationList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

export const editQuotation = async (quotationId, jobId, body) => {
  try {
    const res = await api.edit_quotation(quotationId, jobId, body);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateStatusQuotation = async (body) => {
  try {
    const res = await api.update_status_quotation(body);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const sendQuotation = async (body) => {
  try {
    const res = await api.send_quotation(body);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const quotationDiscountForAll = async (body, jobId) => {
  try {
    const res = await api.quotation_discount_for_all(body, jobId);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const quotationDiscountForSingle = async (body, jobId) => {
  try {
    const res = await api.quotation_discount_on_single(body, jobId);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
